export default __webpack_public_path__ + "static/media/insta.f60b70ed.svg";